'use strict'

import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import veeValidate from 'vee-validate'
import Croppa from 'vue-croppa'
import '@/registerServiceWorker'
import VueScrollTo from 'vue-scrollto'
import {
  format as doFormatTimeAgo,
  register as registerTimeAgo,
} from 'timeago.js'
import moment from 'moment'
import VueCompositionAPI from '@vue/composition-api'

Vue.use(VueCompositionAPI)
Vue.config.productionTip = false
Vue.use(veeValidate)
Vue.use(Croppa)
Vue.use(VueScrollTo, {
  container: '.layout__content',
  easing: 'ease-in',
  force: true,
  cancelable: false,
  x: false,
  y: true,
})

registerTimeAgo('de_DE', function (number, index) {
  // Parameters:
  // number: the time ago / time in number;
  // index: the index of array below;
  // totalSec: total seconds between date to be formatted and today's date;
  return [
    ['gerade eben', 'jetzt gleich'],
    ['vor %s Sekunden', 'in %s Sekunden'],
    ['vor 1 Minute', 'in 1 Minute'],
    ['vor %s Minuten', 'in %s Minuten'],
    ['vor 1 Stunde', 'in 1 Stunde'],
    ['vor %s Stunden', 'in %s Stunden'],
    ['gestern', 'morgen'],
    ['vor %s Tagen', 'in %s Tagen'],
    ['vor 1 Woche', 'in 1 Woche'],
    ['vor %s Wochen', 'in %s Wochen'],
    ['vor 1 Monat', 'in 1 Monat'],
    ['vor %s Monaten', 'in %s Monaten'],
    ['vor 1 Jahr', 'in 1 Jahr'],
    ['vor %s Jahren', 'in %s Jahren'],
  ][index]
})

Vue.mixin({
  methods: {
    formatTimeAgo(date) {
      return doFormatTimeAgo(moment(date).toDate(), 'de_DE')
    },
    str(key, replacements = false) {
      let result = store.getters.str(key)
      if (!replacements) {
        return result
      }

      // Replace all given replacements. This works similar to drupal's t() function.
      return Object.entries(replacements).reduce((result, keyValue) => {
        return result.replace(new RegExp(`${keyValue[0]}`), keyValue[1])
      }, result)
    },
    assetsPath: (file) => {
      return `${store.getters.assetsPath}/${file}`
    },
    formatTemperature(value, showUnit = true) {
      value = parseFloat(value)
      const unit = showUnit ? '°C' : ''
      return value.toFixed(1) + unit
    },
    formatWattage(value, displaySign = false, showDecimalForWatts = false) {
      // We only need to add a plus, since negative numbers automaticalliy get a
      // minus sign.
      const sign = displaySign && value > 0 ? '+' : ''
      value = parseFloat(value)

      // We round to 1k above/below 990W.
      if (value > 990 || value < -990) {
        value = (value / 1000).toFixed(1)
        return sign + value + store.getters.str('units.kilowatt')
      }

      if (!showDecimalForWatts) {
        value = Math.round(value)
      }
      return sign + value + store.getters.str('units.watt')
    },
    formatKWP(value) {
      value = parseFloat(value)
      if (value > 990 || value < -990) {
        value = (value / 1000).toFixed(1)
        value = (value + '').replace(/\./, ',')
        return `${value} ${store.getters.str(`units.kilowattPeak`)}`
      }

      value = (value.toFixed(1) + '').replace(/\./, ',')
      return `${value} ${store.getters.str(`units.wattPeak`)}`
    },
    formatKWH(value) {
      value = parseFloat(value)
      if (value > 990000 || value < -990000) {
        value = (value / 1000000).toFixed(1)
        value = (value + '').replace(/\./, ',')
        return `${value} ${store.getters.str(`units.megawattHours`)}`
      }

      if (value > 990 || value < -990) {
        value = (value / 1000).toFixed(1)
        value = (value + '').replace(/\./, ',')
        return `${value} ${store.getters.str(`units.kilowattHours`)}`
      }

      value = (value.toFixed(1) + '').replace(/\./, ',')
      return `${value} ${store.getters.str(`units.wattHours`)}`
    },
    formatPowerPrice(value, unit = 'centPerKilowatt') {
      if (isNaN(parseFloat(value))) {
        return value
      }

      value = (parseFloat(value) * 100).toFixed(2)
      value = (value + '').replace(/\./, ',')

      let unitText = ''
      if (unit) {
        unitText = store.getters.str(`units.${unit}`)
      }
      return `${value} ${unitText}`
    },
    formatDate(raw, format = 'default') {
      const formats = {
        default: 'DD.MM.YYYY HH:mm',
        date: 'DD.MM.YYYY',
      }
      return moment(raw).format(formats[format])
    },
  },
})

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

if (window.Cypress) {
  // Add the app to the window object to allow full access to vue during e2e tests.
  window.app = app
}

if (store.getters.debug) {
  window.app = app
  window.store = store
  window.router = router
}
